document.addEventListener("DOMContentLoaded", function () {
  const startOverButton = document.getElementById("start-over-button");

  if (startOverButton) {
    startOverButton.addEventListener("click", function () {
      // Reset all Reactify filters
      resetAllFilters();

      // Scroll to first guided filter section
      scrollToFirstGuidedFilter();
    });
  }

  // Resets all active filters by unchecking them
  function resetAllFilters() {
    // Find all checked filter checkboxes in Reactify's sidebar
    const activeCheckboxes = document.querySelectorAll('.rs__filter__list-item input[type="checkbox"]:checked');

    // Uncheck each one to trigger Reactify's filter reset
    activeCheckboxes.forEach((checkbox) => {
      checkbox.click();
    });
  }

  // Scrolls to the first guided filter section with smooth animation
  function scrollToFirstGuidedFilter() {
    // Find the first guided filter section on the page
    const firstSection = document.querySelector(".guided-filter");

    if (firstSection) {
      firstSection.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }
});
